module.exports = __webpack_public_path__ + "img/logo.ac106c80.png";